// @ts-strict-ignore
import { Text } from '../Text'
import { cn } from '@lib/cn'
import React, { FC, InputHTMLAttributes, useState } from 'react'

export interface CheckboxProps extends InputHTMLAttributes<HTMLInputElement> {
  label: React.ReactNode
  id?: string
  hasError?: boolean
}

export const Checkbox: FC<CheckboxProps> = ({ label, hasError, checked, onChange, ...rest }) => {
  const [isChecked, setIsChecked] = useState(checked)
  const id =
    rest.id ||
    rest.name ||
    `id-${[...Array(5)].map((i) => (~~(Math.random() * 36)).toString(36)).join('')}`

  return (
    <div className="relative flex items-start">
      <input
        className={cn(
          'opacity-0 checked:before:border-rolexPrimary checked:before:bg-rolexPrimary',
          'disabled:',
        )}
        type="checkbox"
        checked={checked}
        onChange={(e) => {
          setIsChecked(e.target.checked)
          onChange && onChange(e)
        }}
        id={id}
        {...rest}
      ></input>
      <Text
        variant="legend14"
        className={cn(
          'left-0 block px-2 py-1 font-bold text-shade-800',
          rest.disabled && 'cursor-not-allowed text-shade-500 before:border-shade-300',
        )}
        as="label"
        // @ts-ignore
        htmlFor={id}
      >
        {label}
      </Text>
      <span
        className={cn(
          'absolute left-0 top-[5px] flex h-[14px] w-[14px] items-center justify-center rounded-full border border-solid border-shade-500 bg-transparent p-[2px] transition-all duration-200',
          hasError && 'border-rolexRed text-rolexRed',
          // !hasError && !rest.disabled && 'border-shade-500 hover:text-rolexPrimary',
          isChecked && 'border-rolexPrimary bg-rolexPrimary',
          rest.disabled && 'border-shade-300',
        )}
      >
        <svg enableBackground="new 0 0 15 15" version="1.1" viewBox="0 0 15 15" xmlSpace="preserve">
          <path fill="#fff" d="M4.9 12.8L0 7.1l1.9-1.7 3.2 3.7 8.2-6.9 1.7 2-10.1 8.6z"></path>
        </svg>
      </span>
    </div>
  )
}
